import styled from "styled-components";

export const HistoryContainer = styled.div`
margin-top:1.5rem;

`
export const HistoryTitle = styled.p`
    font-weight: 500;
    text-transform: uppercase;
    color:${(props) => props.theme.textColorPrimary};
`